import { set, remove } from 'lib/storage/versionedLocalStorageUtils'

/*
 * For storage of the trip ID that the user most recently saved to
 * in this session, so we can auto-save to that same trip again if
 * they click a bookmark button within 10 minutes.
 */

const KEY = 'recentlySavedTripId'
const VERSION = 2
type TripIDAndTimestamp = { tripId: string, timestamp: number }

export function setRecentlySavedTripId(tripId: string) {
  set<TripIDAndTimestamp>(KEY, VERSION, { tripId, timestamp: Date.now() })
}

export function clearRecentlySavedTripId() {
  remove(KEY)
}
